import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import { useToastMutation } from '../utils/mutation';

import type { LoadFileField, LoadFileFormat } from '../../types/export';
export type { LoadFileField, LoadFileFormat };

export function useLoadFileFormats(projectId: string) {
  return useQuery<LoadFileFormat[]>({
    queryKey: ['loadFileFormats', projectId],
    queryFn: () => api.get<LoadFileFormat[]>(`/project/${projectId}/loadFileFormat`),
    enabled: !!projectId,
  });
}

export function useSaveLoadFileFormat(projectId: string) {
  return useToastMutation(
    ['loadFileFormats', projectId],
    (format: LoadFileFormat) =>
      format.id
        ? api.put<LoadFileFormat>(`/project/${projectId}/loadFileFormat/${format.id}`, format)
        : api.post<LoadFileFormat>(`/project/${projectId}/loadFileFormat`, format),
    {
      success: (_d, format) => ({ title: `Load File Format ${format.id ? 'updated' : 'added'} successfully`, timeout: 2500 }),
    },
  );
}

export function useDefaultFields() {
  return useQuery<string[]>({
    queryKey: ['defaultFields'],
    queryFn: () => api.get<string[]>('/defaultFields'),
  });
}

export function useImportLoadFileFormats(projectId: string) {
  return useToastMutation(
    ['loadFileFormats', projectId],
    (formats: LoadFileFormat[]) =>
      Promise.all(
        formats.map(({ id: _id, ...format }) =>
          api.post(`/project/${projectId}/loadFileFormat`, { ...format, projectId })
        )
      ),
    {
      success: (_d, formats) => ({ title: `${formats.length} Load File Formats Imported`, timeout: 2500 }),
    }
  );
}
